import { FormattedMessage } from 'react-intl';

import { object, string } from '@/shared/config/yup';

import { API_KEY_COMMENT_MAX_LENGTH } from './constants';

export const apiKeyValidationSchema = object({
  expiresAt: string()
    .required(() => (
      <FormattedMessage
        id="companySettings.apiKeys.expiresAt.required"
        defaultMessage="Expiration date is required"
      />
    ))
    .test(
      'is-future',
      () => (
        <FormattedMessage
          id="companySettings.apiKeys.expiresAt.inPast"
          defaultMessage="Expiration date must be in the future"
        />
      ),
      (value) => !!value && new Date(value).valueOf() > Date.now(),
    ),
  comment: string().max(API_KEY_COMMENT_MAX_LENGTH).default(''),
});
